import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import {GetAccessRes} from "../../../models/http/http-auth-model";


export class SetAccess {
  static readonly type = '[Access] Set';
  constructor(public payload: GetAccessRes) {}
}

export class ClearAccess {
  static readonly type = '[Access] Clear';
}

export interface AccessStateModel {
  data: GetAccessRes | null;
}

@State<AccessStateModel>({
  name: 'access',
  defaults: {
    data: null
  }
})
@Injectable()
export class AccessState {
  // ✅ Selector
  @Selector()
  static getAccess(state: AccessStateModel) {
    return state.data;
  }

  // ✅ Actions
  @Action(SetAccess)
  setAccess(ctx: StateContext<AccessStateModel>, action: SetAccess) {
    ctx.patchState({ data: action.payload });
  }

  @Action(ClearAccess)
  clearAccess(ctx: StateContext<AccessStateModel>) {
    ctx.patchState({ data: null });
  }
}
